import * as React from 'react';
import { TableCell, TableRow } from '@telia-front/table';
import CompareCheck from './compare-check';
import ComparisonImage from './image';
import NameRow from './name-row';
import { Placeholder } from './placeholder';
import Table from './table';
import Title from './title';
import { cellBEM, usePlaceholderArray } from './utils';
const HeaderTable = (props) => {
    const { items, placeholder, isMobile, title, deviceLabel, compareCheckLabel, isCompareChecked, onCompareCheckChange, elementRef, onScroll, isDisabled = false, } = props;
    const placeholders = usePlaceholderArray(items.length);
    const totalItemCount = items.length + placeholders.length;
    const cellWidth = (isMobile ? 12 / totalItemCount : 2);
    return (React.createElement(Table, { itemCount: items.length, isMobile: isMobile, elementRef: elementRef, onScroll: onScroll },
        React.createElement("tbody", null,
            React.createElement(TableRow, { className: "product-comparison__table-row product-comparison__table-row-no-borders product-comparison__table-row--images" },
                isMobile ? (React.createElement(TableCell, { width: 3, className: "product-comparison__title-cell sr-only" })) : (React.createElement(TableCell, { width: 3, className: "product-comparison__title-cell" },
                    React.createElement(Title, { title: title }),
                    React.createElement(CompareCheck, { id: "affix", onChange: onCompareCheckChange, checked: isCompareChecked, disabled: items.length < 2 || isDisabled, labelText: compareCheckLabel }))),
                items.map((child, index) => {
                    return (React.createElement(TableCell, { className: cellBEM(), width: cellWidth, key: index, valign: "top" },
                        React.createElement(ComparisonImage, { image: child.image, button: child.button, isDisabled: isDisabled, onRemoveButtonClick: child.onRemoveButtonClick })));
                }),
                placeholders.map((_i, index) => {
                    return (React.createElement(TableCell, { className: cellBEM(), width: cellWidth, key: `placeholder-${index}`, valign: "top" }, index === 0 && React.createElement(Placeholder, Object.assign({}, placeholder))));
                })),
            React.createElement(NameRow, { renderButton: true, items: items, deviceLabel: deviceLabel, isMobile: isMobile, cellWidth: cellWidth, isDisabled: isDisabled }))));
};
export default HeaderTable;
